import { Component, OnInit } from '@angular/core';
import { MessageWrapperService } from 'src/app/services/message-wrapper.service';
import { ExportGenSvc, ExportModel } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-export-page',
    templateUrl: './export-page.component.html',
    styleUrls: ['./export-page.component.css'],
    standalone: false
})
export class ExportPageComponent implements OnInit {
  isLoading: boolean = false;

  exports: ExportModel[] = [];

  public filterStartDate: Date;
  public filterEndDate: Date;

  constructor(private exportService: ExportGenSvc,
              private messageService: MessageWrapperService) { }

  ngOnInit() {
    this.filterStartDate = new Date(new Date().getFullYear(), 0, 1);
    this.filterEndDate = new Date();

    this.isLoading = true;
    this.exportService.get().subscribe(res => {
      this.isLoading = false;
      this.exports = res;
    }, err => {
      this.isLoading = false;
      this.messageService.addErrorMessage('Could not load exports, please refresh and try again.', err);
    });
  }

}
